module.exports = __webpack_public_path__ + "static/media/banner-keyman-2@3x.5110b19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-keyman-2@3x.png
// module id = 1253
// module chunks = 1